export const CLARITY_ONE_COOKIE_NAME = "clarity_one_session_id";
export const CLARITY_ONE_UNAUTHED_ERR_MSG = "Please sign in to Clarity One (20001)";
